module.exports = __webpack_public_path__ + "static/media/profile.cb6e0865.jpg";